// x-media-wide.js

/*
In this script:
- Frontpage add class to body if page-top class on row, to enable styling of header etc
- Background-video component pause-button functionality
*/

class xMediaWide {

  /****************************************************************************************
   * Frontpage add class to body if page-top class on row, to enable styling of header etc
  *****************************************************************************************/

  pageTopMedia() {
    const pageTopRow = document.querySelector(".grid-container.page-top");
    if (pageTopRow) {
      document.body.classList.add("has-page-top-row");
    }
    const pageTopRowWhite = document.querySelector(".grid-container.page-top-white");
    if (pageTopRowWhite) {
      document.body.classList.add("has-page-top-row-white");
    }
  }

  /***************************************************************************************
   * Background-video component pause-button functionality
  ****************************************************************************************/

  backgroundVideo() {
    const bgVideoContainers = document.querySelectorAll(".vrtx-background-video");
    bgVideoContainers.forEach(bgVideoContainer => {

      // Pause-button
      const bgVideoPauseButton = bgVideoContainer.querySelector(".pause-video");
      bgVideoPauseButton.addEventListener("click", pauseVideo);

      const bgVideo = bgVideoContainer.querySelector("video");
      bgVideo.addEventListener("click", pauseVideo);

      function pauseVideo() {
        bgVideoPauseButton.classList.toggle("paused");

        if (bgVideo.paused) {
          bgVideo.play();
        }
        else {
          bgVideo.pause();
        }
      }
    });
  }
}
export default new xMediaWide;